<!-- @format -->

<ng-container *transloco="let t">
  <sis-common-attainment-details [attainment]="attainment" [secondaryAttainments]="secondaryAttainments">
    @if (expirationImminent) {
      <ng-template #expirationNotification>
        <sis-attainment-expiration-notification [attainment]="attainment"></sis-attainment-expiration-notification>
      </ng-template>
    }
    <ng-template #curriculumPeriods>
      <div sis-curriculum-periods-details class="form-group-mimic" role="listitem" [attainment]="attainment"></div>
    </ng-template>

    <ng-template #registrationDetails>
      <div class="form-group-mimic" role="listitem">
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.REGISTRATION_DATE") }}</dt>
        <dd>{{ attainment.registrationDate | localDateFormat }}</dd>
      </div>
    </ng-template>
  </sis-common-attainment-details>
</ng-container>
